import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

const FulfillmentStatistics = lazy(async () => {
  const { FulfillmentStatistics } = await import(
    /* webpackChunkName: "FulfillmentStatistics" */ '../../../components/pages/private/FulfillmentStatistics'
  )

  return {
    default: FulfillmentStatistics,
  }
})

export const fulfillmentStatistics: JSX.Element[] = [
  <Route
    element={<FulfillmentStatistics />}
    key={paths('/fulfillment-statistics')}
    path={paths('/fulfillment-statistics')}
  />,
]
